import { convertFileToBase64 } from 'app/utils';
import axios from 'axios';

export type GetPensioenbijEventsArgs = {
  page?: number;
  pageSize?: number;
  status?: string[];
  searchQuery?: string;
};

export type ResendPensioenbijEventsArgs = {
  connectionId: string | null;
  mutationIds: string[];
};

export type GetOwnerEmployersArgs = {
  ownerId: string;
  page?: number;
  itemsPerPage?: number;
  searchQuery?: string;
};

export type GetDeletedConnectionsArgs = {
  employerId: string;
  page?: number;
  itemsPerPage?: number;
};

export type RestoreConnectionArgs = {
  connectionId: string;
};

export const toolsServices = {
  async getPensioenbijEvents({ page, pageSize, status, searchQuery }: GetPensioenbijEventsArgs) {
    return axios.get(`connections/mutations`, { params: { page, pageSize, status, searchQuery } });
  },

  async resendPensioenbijEvents({ connectionId, mutationIds }: ResendPensioenbijEventsArgs) {
    return axios.post(`connections/mutations`, { connectionId, mutationIds });
  },

  async uploadNaverrekenenTemplate(file: File) {
    return axios.post(`tools/naverrekenen-template`, {
      parameters: {
        fileName: file.name,
      },
      base64FileContent: await convertFileToBase64(file),
    });
  },

  async getOwnerEmployers({ ownerId, page = 1, itemsPerPage = 30, searchQuery }: GetOwnerEmployersArgs) {
    return axios.get(`/admin/owners/${ownerId}/employers`, {
      params: { page, itemsPerPage, searchQuery },
    });
  },

  async getDeletedConnections({ employerId, page = 1, itemsPerPage = 30 }: GetDeletedConnectionsArgs) {
    return axios.get(`/admin/employers/${employerId}/deleted-connections`, {
      params: { page, itemsPerPage },
    });
  },

  async restoreConnection({ connectionId }: RestoreConnectionArgs) {
    return axios.put(`/admin/connections/${connectionId}/restore`, {});
  },
};
